<template>
  <div>
    <a @click="onCheckout">
      <div class="payPal">
        <div class="responsivePayPal">
          <img
            src="@/assets/img/paypal-color.svg"
            alt="Check out with PayPal"
          />
        </div>
      </div>
    </a>
    <label v-if="false" :class="{ label: true, active: active }" for="paypal">
      <input
        id="paypal"
        v-model="gateway"
        type="radio"
        name="payment_method"
        data-target="#credit_card1"
        value="paypal"
        required=""
        class=""
      />
      <span>{{ method.name }}</span>

      <img
        id="paypal-logo"
        src="@/assets/img/paypal-color.svg"
        alt="PayPal Logo"
      />
    </label>
    <div id="credit_card1" class="description collapse">
      <p class="card-des">
        Pay via PayPal; you can pay with your credit card if you don’t have a
        PayPal account. SANDBOX ENABLED. You can use sandbox testing accounts
        only. See the
        <a
          href="https://developer.paypal.com/docs/classic/lifecycle/ug_sandbox/"
          >PayPal Sandbox Testing Guide</a
        >
        for more details.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "../../event-bus";

export default {
  name: "PayPalMethod",

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    method: {
      type: Object,
      default: function () {
        return {
          gateway: "paypal",
          name: "PayPal",
          client_side_gateway: null,
        };
      },
    },
  },

  computed: {
    ...mapState({
      cart: (state) => state.cart,
    }),
    gateway: {
      get() {
        return this.$store.state.payment.gateway;
      },
      set(value) {
        this.$store.commit("setGateway", value);
      },
    },
  },

  methods: {
    onCheckout() {
      console.log("onCheckout");
      EventBus.$emit("paypal-standard-checkout", this.method);
    },
  },
};
</script>

<style scoped>
#paypal-logo {
  width: 25%;
}

.payPal {
  width: 100%;
  height: 44px;
  cursor: pointer;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background-color: #ffc439;
}
.payPal:hover,
.payPal:active,
.payPal:focus {
  background-color: #ffbc20;
}

.responsivePayPal {
  height: 44px;
  width: 150px;
  overflow: hidden;
  margin: auto;
  padding-top: 2px;
}

.responsivePayPal img {
  position: relative;
  height: 34px;
  top: 4px;
  right: -15px;
}
</style>
